import React from 'react';

export const Special = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2244 2.0532C15.4335 2.15822 15.5418 2.39426 15.4851 2.6213L13.6404 10H18C18.1907 10 18.3648 10.1085 18.4488 10.2796C18.5329 10.4508 18.5122 10.6549 18.3956 10.8058L9.89565 21.8058C9.75096 21.993 9.49481 22.0532 9.28188 21.9499C9.06894 21.8467 8.95754 21.6083 9.01493 21.3788L10.8596 14H6.00001C5.80681 14 5.6309 13.8887 5.54817 13.7141C5.46544 13.5396 5.49069 13.3329 5.61303 13.1834L14.613 2.18341C14.7612 2.00228 15.0152 1.94818 15.2244 2.0532ZM7.05513 13H11.5C11.654 13 11.7994 13.071 11.8941 13.1923C11.9889 13.3137 12.0224 13.4719 11.9851 13.6213L10.5641 19.3053L16.9818 11H13C12.846 11 12.7007 10.9291 12.6059 10.8077C12.5111 10.6864 12.4776 10.5281 12.5149 10.3788L13.9736 4.54413L7.05513 13Z"
      fill="#5A6474"
    />
  </svg>
);
